import Icon from 'veui/components/Icon'
import { IconPlus } from 'dls-icons-vue'

Icon.register('plus', IconPlus)
